import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '../../query-client';
import { IFetchPageQuery } from '../IFetchQueryOptions';
import { IPagination } from '../IPagination';
import { fetchVendors } from './index';
import { IVendor } from './interface';

export const useVendorListQuery = (query: IFetchPageQuery, options = {}) => {
    return useQuery<IPagination<IVendor>, Error>([QueryKey.VENDORS, query], ({ signal }) => fetchVendors(query, signal), {
        ...options,
        keepPreviousData: true,
    });
};
